export default __webpack_public_path__ + "static/media/goshin_scotland.06286bc0.jpg";